import React from 'react';
import './LessonCommResponsesPanel.css';

/**
 * 수업 프레젠(칠판) — 질문 QR(소통방)로 들어온 학생 기기의 실시간 응답 (번호 + 별칭).
 * 화면 보기 전용: 응답 수/목록만 표시하고, 질문 닫기는 리모컨이나 이 패널에서.
 */
export type LessonCommResponseRow = {
  memberId: string;
  label: string;
  content: string;
  at: number;
};

const LessonCommResponsesPanel: React.FC<{
  questionText: string;
  rows: LessonCommResponseRow[];
  joinedCount: number;
  connected: boolean;
  onCloseQuestion: () => void;
  /** 하단 안내(예: 저장하면 응답이 기록돼요) */
  note?: string;
}> = ({ questionText, rows, joinedCount, connected, onCloseQuestion, note }) => {
  const [collapsed, setCollapsed] = React.useState(false);
  return (
    <section className={`cp-lesson-comm-panel${collapsed ? ' is-collapsed' : ''}`} aria-label="학생 기기 응답">
      <header className="cp-lesson-comm-panel-head">
        <button
          type="button"
          className="cp-lesson-comm-panel-toggle"
          onClick={() => setCollapsed((v) => !v)}
          aria-expanded={!collapsed}
          title={collapsed ? '펼치기' : '접기'}
        >
          <span className="cp-lesson-comm-panel-title">
            학생 기기 응답 <b>{rows.length}</b>
            {joinedCount ? <span className="cp-lesson-comm-panel-total">/{joinedCount}</span> : null}
          </span>
          {!connected ? <span className="cp-lesson-comm-panel-warn">연결 끊김</span> : null}
        </button>
        <button type="button" className="cp-lesson-comm-panel-close" onClick={onCloseQuestion} title="학생 기기 질문 닫기">
          닫기
        </button>
      </header>
      {collapsed ? null : (
        <>
          <p className="cp-lesson-comm-panel-q">{questionText}</p>
          {rows.length ? (
            <ul className="cp-lesson-comm-panel-list">
              {rows.map((r) => (
                <li key={r.memberId}>
                  <span className="cp-lesson-comm-panel-name">{r.label}:</span>
                  <span className="cp-lesson-comm-panel-ans">{r.content}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="cp-lesson-comm-panel-empty">아직 응답이 없어요</p>
          )}
          {note ? <p className="cp-lesson-comm-panel-note">{note}</p> : null}
        </>
      )}
    </section>
  );
};

export default LessonCommResponsesPanel;
